import { apiRequest } from "./client";
import {
    ChangePasswordPayload,
    ForgotPasswordPayload,
    LoginPayload,
    ResetPasswordPayload,
    TokenResponse,
} from "../types/auth.types";

export const loginRequest = async (payload: LoginPayload): Promise<TokenResponse> => {
    const body = new URLSearchParams();
    body.append("username", payload.email);
    body.append("password", payload.password);
    body.append("grant_type", "password");

    return apiRequest<TokenResponse>("/auth/admin/login", {
        method: "POST",
        body,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        auth: false,
    });
};

export const forgotPasswordRequest = async (
    payload: ForgotPasswordPayload
): Promise<void> => {
    await apiRequest<void>("/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: false,
    });
};

export const resetPasswordRequest = async (
    payload: ResetPasswordPayload
): Promise<void> => {
    await apiRequest<void>("/auth/reset-password", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: false,
    });
};

export const changePasswordRequest = async (
    payload: ChangePasswordPayload
): Promise<void> => {
    await apiRequest<void>("/auth/change-password", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};


// POST /auth/register — создание клиента из панели управления (без welcome email)
export interface RegisterCustomerPayload {
    first_name: string;
    last_name: string;
    email: string;
    password: string;
    send_welcome_email?: boolean;
}

export const registerCustomerRequest = async (
    payload: RegisterCustomerPayload,
): Promise<TokenResponse> => {
    return apiRequest<TokenResponse>("/auth/register", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
        auth: false,
    });
};
